<div class="main">
  <div class="">
    <i *ngIf="data.icon_class" class="fa {{data.icon_class}}" [ngStyle]="{'color': data.icon_color ? data.icon_color : '#fff'}"></i>
    <span>{{data.text}}</span>
  </div>
  <i *ngIf="data.close" class="fa fa-times" (click)="snackBarRef.dismiss()"></i>
</div>
